import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import NovidadesBar from './components/NovidadesBar';
import ScrollToHash from './components/ScrollToHash';
import Home from './pages/Home';
import Guias from './pages/Guias';
import MetodologiaDaCalculadora from './pages/MetodologiaDaCalculadora';
import EvidenciaBrasileira from './pages/EvidenciaBrasileira';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import Escolaridade from './pages/Escolaridade';
import PontosDeCorte from './pages/PontosDeCorte';
import InterpretacaoDosResultados from './pages/InterpretacaoDosResultados';
import MiniMentalOuMoca from './pages/MiniMentalOuMoca';
import QuemPodeAplicar from './pages/QuemPodeAplicar';
import DiagnosticaAlzheimer from './pages/DiagnosticaAlzheimer';
import MeemIncompleto from './pages/MeemIncompleto';
import ComoAplicar from './pages/ComoAplicar';
import ErrosDeAplicacao from './pages/ErrosDeAplicacao';
import FormularioEDireitosDeUso from './pages/FormularioEDireitosDeUso';
import MiniMentalETesteDoRelogio from './pages/MiniMentalETesteDoRelogio';
import AcompanhamentoEQuedaDePontos from './pages/AcompanhamentoEQuedaDePontos';
import AdaptacoesSensoriais from './pages/AdaptacoesSensoriais';
import MiniMentalTelessaude from './pages/MiniMentalTelessaude';
import Sobre from './pages/Sobre';
import MiniExameDoEstadoMental from './pages/MiniExameDoEstadoMental';
import MiniMentalPdf from './pages/MiniMentalPdf';
import PentagonosMiniMental from './pages/PentagonosMiniMental';
import Pro from './pages/Pro';
import Avaliacao from './pages/Avaliacao';
import ResultadoPontuacao from './pages/ResultadoPontuacao';
import DominioMeem from './pages/DominioMeem';
import Gestao from './pages/Gestao';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Support from './pages/Support';
import ResetPassword from './pages/ResetPassword';
import { LocaleProvider, useLocale } from './components/LocaleProvider';
import SpanishHome from './pages/es/SpanishHome';
import SpanishIntentPage from './pages/es/SpanishIntentPage';
import SpanishInstitutionalPage from './pages/es/SpanishInstitutionalPage';
import { SPANISH_PAGES } from './lib/site';

function LocalizedHome() {
  const { locale } = useLocale();
  return locale === 'es' ? <SpanishHome /> : <Home />;
}

function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToHash />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<LocalizedHome />} />
          <Route path="/es" element={<SpanishHome />} />
          {SPANISH_PAGES.filter((page) => page.path !== '/es').map((page) => <Route key={page.path} path={page.path} element={page.type === 'institutional' ? <SpanishInstitutionalPage page={page} /> : <SpanishIntentPage page={page} />} />)}
          <Route path="/guias" element={<Guias />} />
          <Route path="/metodologia-da-calculadora" element={<MetodologiaDaCalculadora />} />
          <Route path="/evidencia-brasileira" element={<EvidenciaBrasileira />} />
          <Route path="/escolaridade" element={<Escolaridade />} />
          <Route path="/pontos-de-corte" element={<PontosDeCorte />} />
          <Route path="/interpretacao-dos-resultados" element={<InterpretacaoDosResultados />} />
          <Route path="/mini-mental-ou-moca" element={<MiniMentalOuMoca />} />
          <Route path="/quem-pode-aplicar" element={<QuemPodeAplicar />} />
          <Route path="/diagnostica-alzheimer" element={<DiagnosticaAlzheimer />} />
          <Route path="/meem-incompleto" element={<MeemIncompleto />} />
          <Route path="/como-aplicar" element={<ComoAplicar />} />
          <Route path="/erros-de-aplicacao" element={<ErrosDeAplicacao />} />
          <Route path="/formulario-e-direitos-de-uso" element={<FormularioEDireitosDeUso />} />
          <Route path="/mini-mental-e-teste-do-relogio" element={<MiniMentalETesteDoRelogio />} />
          <Route path="/acompanhamento-e-queda-de-pontos" element={<AcompanhamentoEQuedaDePontos />} />
          <Route path="/adaptacoes-sensoriais" element={<AdaptacoesSensoriais />} />
          <Route path="/mini-mental-telessaude" element={<MiniMentalTelessaude />} />
          <Route path="/mini-exame-do-estado-mental" element={<MiniExameDoEstadoMental />} />
          <Route path="/mini-mental-pdf" element={<MiniMentalPdf />} />
          <Route path="/pentagonos-mini-mental" element={<PentagonosMiniMental />} />
          <Route path="/pro" element={<Pro />} />
          <Route path="/avaliacao/:token" element={<Avaliacao />} />
          <Route path="/resultado/:slug" element={<ResultadoPontuacao />} />
          <Route path="/dominio/:slug" element={<DominioMeem />} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route path="/gestao" element={<Dashboard />} />
          <Route path="/conta" element={<Dashboard />} />
          <Route path="/dashboard" element={<Gestao />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/suporte" element={<Support />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/politica-de-privacidade" element={<Privacy />} />
          <Route path="/termos-de-uso" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <NovidadesBar />
    </div>
  );
}

function App() {
  return <LocaleProvider><AppLayout /></LocaleProvider>;
}

export default App;
